import { render, staticRenderFns } from "./beneficial-ownership.vue?vue&type=template&id=a061956a&"
import script from "./beneficial-ownership.vue?vue&type=script&lang=ts&"
export * from "./beneficial-ownership.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports